<template>
  <section-hoc mode="center" :variant="4" class="wrapper" size="cover">
    <div class="wrapper">
      <div class="flex-row speaker">
        <h2 class="speaker__name" style="color: var(--lt2);">
          <slot></slot>
        </h2>
      </div>
    </div>
  </section-hoc>
</template>

<script>
import SectionHoc from "./SectionHoc";

export default {
  components: { "section-hoc": SectionHoc }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.speaker {
  margin: auto 2em;
  align-items: center;
  justify-content: flex-end;
}

.title {
}
</style>